import React from "react";
import { Sparkles } from "lucide-react";

/**
 * TourButton — floating call-to-action that re-launches a guided tour.
 *
 * Renders a fixed pill in the bottom-right corner. The pulse ring nudges
 * first-time users without being annoying (CSS only, no JS animations).
 */
export function TourButton({ onClick, label = "Ver tour", showPulse = true }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="tour-trigger-btn"
            data-testid="tour-trigger-btn"
            aria-label={label}
        >
            {showPulse && <span className="tour-trigger-pulse" />}
            <Sparkles size={14} />
            <span className="relative">{label}</span>
        </button>
    );
}

export default TourButton;
